<!-- eslint-disable -->
<div
	class="slider rounded"
	draggable="false"
	#slider
	draggable="false"
	[ngStyle]="globalStyle"
>
	<img
		[src]="sliderConfig.preImageUrl"
		#preImg
		draggable="false"
		(load)="onPreImageLoad()"
		(error)="onPreImageError()"
		[ngStyle]="preImageStyle"
	/>
	<div
		class="resizer"
		#resizer
	>
		<img
			[src]="sliderConfig.postImageUrl"
			#postImg
			draggable="false"
			(load)="onPostImageLoad()"
			(error)="onPostImageError()"
			[ngStyle]="postImageStyle"
		/>
	</div>
	<span
		class="grip"
		#grip
	></span>
</div>
